import { FtblMatchInfo } from './ftblMatchInfo.types';

export const parseFtblMatchInfo = (matchInfoRaw: string): FtblMatchInfo | null => {
    if (!matchInfoRaw) {
        return null;
    }

    try {
        return JSON.parse(matchInfoRaw) as FtblMatchInfo;
    } catch {
        return null;
    }
};
import { FtblMatchInfo } from './ftblMatchInfo.types';

export const parseFtblMatchInfo = (matchInfoRaw: string): FtblMatchInfo | null => {
    if (!matchInfoRaw) {
        return null;
    }

    try {
        return JSON.parse(matchInfoRaw) as FtblMatchInfo;
    } catch {
        return null;
    }
};
